export type ThemeTP = 'light' | 'dark'

export const THEME_LOCAL_STORAGE_KEY = 'theme'
